/* eslint-disable arrow-body-style */
export default function createMethods(session: any) {
	return {
		// Data Management --------------------------------------------------------
		loadMine: (mine: any) => session.call("datacloud.mine.load", [mine]),
		configureMine: (config: any) => session.call("datacloud.mine.configure", [config]),
		loadPieces: (viewId: any, layers: any) =>
			session.call("datacloud.layer.pieces.load", [viewId, layers]),
		getHistogram: (layerName: any, viewId: any, field: any, dataRange: any, nbBins: any) =>
			session.call("datacloud.histogram.get", [layerName, viewId, field, dataRange, nbBins]),
		// Pub/Sub ----
		subscribeToLayerState: (callback: any) =>
			session.subscribe("datacloud.layer.state.update", callback).promise,
		unsubscribeToLayerState: (subscription: any) => session.unsubscribe(subscription),
		// API backup -------------------------------------------------------------
		getDatasetConfig: () => session.call("datacloud.mine.dataset.config", []),
		getAllHierarchy: () => session.call("datacloud.mine.hierarchy.all", []),
		// View Management --------------------------------------------------------
		getLayout: () => session.call("datacloud.views.layout", []),
		setLayout: (layout: any) => session.call("datacloud.views.layout.set", [layout]),
		getViews: () => session.call("datacloud.views.list", []),
		addView: (kind: any) => session.call("datacloud.view.add", [kind]),
		removeView: (viewId: any) => session.call("datacloud.view.remove", [viewId]),
		resetCamera: (viewId: any, bounds = undefined) =>
			session.call("datacloud.view.camera.reset", [viewId, bounds]),
		setViewUp: (viewId: any, viewType: any, bounds = undefined, northPole = true) =>
			session.call("datacloud.set.view.up", [viewId, viewType, bounds, northPole]),
		setCameraCenter: (viewId: any, center: any) =>
			session.call("datacloud.view.camera.center", [viewId, center]),
		updateActiveLayerInView: (viewId: any, layerName: any) =>
			session.call("datacloud.view.active.layer.update", [viewId, layerName]),
		updateViewState: (viewId: any, changeSet: any) =>
			session.call("datacloud.view.update.state", [viewId, changeSet]),
		updateViewLink: (viewId: any, linkState: any) =>
			session.call("viewport.view.link", [viewId, linkState]),
		// Pub/Sub ----
		subscribeToViewState: (callback: any) =>
			session.subscribe("datacloud.view.state.update", callback).promise,
		unsubscribeToViewState: (subscription: any) => session.unsubscribe(subscription),
		subscribeToRepresentationState: (callback: any) =>
			session.subscribe("datacloud.representation.state.update", callback).promise,
		unsubscribeToRepresentationState: (subscription: any) => session.unsubscribe(subscription),
		subscribeToSelectionSize: (callback: any) =>
			session.subscribe("datacloud.selection.size.update", callback).promise,
		unsubscribeToSelectionSize: (subscription: any) => session.unsubscribe(subscription),
		// State Management --------------------------------------------------------
		pushServerState: () => session.call("datacloud.server.state.push", []),
		// Filtering management ----------------------------------------------------
		updateClip: (layerName: any, viewId: any, state: any) =>
			session.call("datacloud.filtering.clip.update", [layerName, viewId, state]),
		applyClipToLayers: (layerName: any, viewId: any, layersToClip: any, options: any) =>
			session.call("datacloud.filtering.clip.apply.layers", [
				layerName,
				viewId,
				layersToClip,
				options
			]),
		// Representation management ----------------------------------------------
		updateColorBy: (layerName: any, viewId: any, state: any) =>
			session.call("datacloud.representation.color.by", [layerName, viewId, state]),
		setFieldList: (layerName: any, viewId: any, list: any) =>
			session.call("datacloud.representation.fieldlist.set", [layerName, viewId, list]),
		updateRepresentationProperty: (
			layerName: any,
			viewId: any,
			type: any,
			name: any,
			value: any
		) =>
			session.call("datacloud.representation.property.update", [
				layerName,
				viewId,
				type,
				name,
				value
			]),
		// Color presets ----------------------------------------------------------
		getPresetImage: (presetName: any, numSamples: any, invert = false) =>
			session.call("datacloud.color.preset.image", [presetName, numSamples, invert]),
		// Processing management --------------------------------------------------
		addThresholdFilter: (
			layerName: any,
			viewId: any,
			field: any,
			location: any,
			dataRange: any
		) =>
			session.call("datacloud.filtering.threshold.add", [
				layerName,
				viewId,
				field,
				location,
				dataRange
			]),
		removeThresholdFilter: (layerName: any, viewId: any, filterId: any) =>
			session.call("datacloud.filtering.threshold.remove", [layerName, viewId, filterId]),
		updateThresholdFilter: (layerName: any, viewId: any, state: any) =>
			session.call("datacloud.filtering.threshold.update", [layerName, viewId, state]),
		// ------------------------------------------------------------------------
		enableSliceFilter: (layerName: any, viewId: any) =>
			session.call("datacloud.filtering.slice.enable", [layerName, viewId]),
		disableSliceFilter: (layerName: any, viewId: any) =>
			session.call("datacloud.filtering.slice.disable", [layerName, viewId]),
		addSliceFilter: (layerName: any, viewId: any) =>
			session.call("datacloud.filtering.slice.add", [layerName, viewId]),
		removeSliceFilter: (layerName: any, viewId: any, filterId: any) =>
			session.call("datacloud.filtering.slice.remove", [layerName, viewId, filterId]),
		updateSliceFilter: (layerName: any, viewId: any, state: any) =>
			session.call("datacloud.filtering.slice.update", [layerName, viewId, state]),
		// picking ----------------------------------------------------------------
		updateUserEdits: (layerName: any, viewId: any, active: any) =>
			session.call("datacloud.filtering.user.edits.update", [layerName, viewId, active]),
		updateExportSelection: (layerName: any, viewId: any, active: any) =>
			session.call("datacloud.filtering.export.selection.update", [
				layerName,
				viewId,
				active
			]),
		pick: (event: any, layerName: any) =>
			session.call("datacloud.view.pick.point", [event, layerName]),
		pickArea: (viewId: any, area: any, layerName: any, mode: any, fullHole: any) =>
			session.call("datacloud.view.pick.area", [viewId, area, layerName, mode, fullHole]),
		pickPolygon: (viewId: any, points: any, layerName: any, mode: any, fullHole: any) =>
			session.call("datacloud.view.pick.polygon", [
				viewId,
				points,
				layerName,
				mode,
				fullHole
			]),
		clearPickSelection: (viewId: any, layerName: any) =>
			session.call("datacloud.view.selection.clear", [viewId, layerName]),
		applyChangeset: (viewId: any, layerName: any, field: any, value: any) =>
			session.call("datacloud.changeset.apply", [viewId, layerName, field, value]),
		removeLastChangeset: (viewId: any, layerName: any) =>
			session.call("datacloud.changeset.removelast", [viewId, layerName]),
		getSelectedDataAsCSV: (viewId: any, layerName: any) =>
			session.call("datacloud.view.selection.csv.get", [viewId, layerName]),
		// application state management -------------------------------------------
		getApplicationState: () => session.call("datacloud.application.state.get", []),
		setApplicationState: (state: any) =>
			session.call("datacloud.application.state.set", [state]),
		resetViews: (viewToReset: any, viewToDelete = []) =>
			session.call("datacloud.application.state.view.reset", [viewToReset, viewToDelete]),
		cloneView: (viewId: any) => session.call("datacloud.application.state.view.clone", [viewId])
	};
}
